module.exports = __webpack_public_path__ + "assets/be853fe9bee06a062a9418e6e7fa1af7.png";